import {
	getAction
} from '@/api/index';
import * as echarts from 'echarts'
import 'echarts/map/js/china.js'
import {
	mapGetters
} from 'vuex'
const chinaGeoCoordMap = {
	"河北": [114.4995, 38.1006],
	"山西": [112.3352, 37.9413],
	"辽宁": [123.1238, 42.1216],
	"吉林": [125.8154, 44.2584],
	'黑龙江': [127.9688, 45.368],
	"江苏": [118.8062, 31.9208],

	"浙江": [119.5313, 29.8773],
	"安徽": [117.29, 32.0581],
	"福建": [119.4543, 25.9222],
	"江西": [116.0046, 28.6633],
	"山东": [117.1582, 36.8701],
	"河南": [113.4668, 34.6234],

	"湖北": [114.3896, 30.6628],
	"湖南": [113.0823, 28.2568],
	"广东": [113.12244, 23.009505],
	"海南": [110.3893, 19.8516],
	"四川": [103.9526, 30.7617],
	"贵州": [106.6992, 26.7682],

	"云南": [102.9199, 25.4663],
	"陕西": [109.1162, 34.2004],
	"甘肃": [103.5901, 36.3043],
	"青海": [101.4038, 36.8207],
	"台湾": [121.5774, 25.01056],

	'北京': [116.4551, 40.2539],
	"天津": [117.4219, 39.4189],
	'上海': [121.4648, 31.2891],
	"重庆": [108.384366, 30.439702],

	'内蒙古': [110.3467, 41.4899],
	"宁夏": [106.3586, 38.1775],
	"新疆": [87.9236, 43.5883],
	"西藏": [91.11, 29.97],
	"广西": [108.479, 23.1152],

	"香港": [114.16817, 22.25989],
	"澳门": [113.53029, 22.13714]

};
export default {
	data() {
		return {
			chart: null,
			url: {
				listProject: '/officialWebsite/c-api/project/list'
			},
			listData: [],
			echartRect: {},
			curPopListStatus: {
				x: 0,
				y: 0,
				show: false,
				timeOut: null,
				curNodeName: ''
			}
		}
	},
	watch: {
		scaleRate: {
			handler(val, oldValue) {
				if(this.$route.path == '/project') {
					this.curPopListStatus.show = false;
					this.initChart();
					this.chart.resize();
				}
			},
			//立刻执行handler
			//immediate: true
		},
		'$route.path': {
			handler(val, oldValue) {
				if(val == '/project' && val != oldValue) {
					this.curPopListStatus.show = false;
					this.initChart();
					this.chart.resize();
				}
			},
		}
	},
	computed: {
		...mapGetters(["scaleRate","isVerticalScreen"]),
		popListItems() {
			if(this.curPopListStatus.curNodeName) {
				return this.listData.filter(it => 
					(it.projectLocation && it.projectLocation.type == 0 && it.projectLocation.provinceTxt 
					&& it.projectLocation.provinceTxt.indexOf(this.curPopListStatus.curNodeName)==0) 
					|| (it.projectLocation && it.projectLocation.type == 1 && it.countryInf 
					&& it.countryInf.countryChinese == this.curPopListStatus.curNodeName));
			}
			return []
		},
		popBgStyle() {
			if(this.echartRect.width / 2 < this.curPopListStatus.x) {
				return {
					transform: 'rotateY(180deg)'
				}
			}
			return {};
		},
		popListStyle() {
			if(this.curPopListStatus.show) {
				let offsetX = this.isVerticalScreen ? 52 : 75;
				let offsetY = this.isVerticalScreen ? 50 : 0;
				let left = 0;
				if(this.echartRect.width / 2 < this.curPopListStatus.x) {
					left = this.curPopListStatus.x + this.scaleRate * (offsetX + ( - 189 + 35) * (this.isVerticalScreen ? 1.4 : 1));
				}else {
					left = this.scaleRate * (offsetX - 35 * (this.isVerticalScreen ? 1.4 : 1)) + this.curPopListStatus.x;
				}
				return {
					left: left + 'px',
					top: (this.curPopListStatus.y + offsetY * this.scaleRate) + 'px',
					display: 'block'
				}
			}else {
				return {
					display: 'none'
				}
			}
			
		}
	},
	mounted() {
		this.loadData();
	},
	beforeDestroy() {
		if (!this.chart) {
			return
		}
		this.chart.dispose()
		this.chart = null
	},
	methods: {
		async loadData() {
			const res = await getAction(this.url.listProject);
			if (res.success) {
				this.listData = res.result;
				//console.log(this.listData)
				this.initChart()
			}
		},
		getProjectLocation(rec) {
			if(rec.projectLocation && rec.projectLocation.type == 0) {
				return rec.projectLocation.provinceTxt + rec.projectLocation.cityTxt;
			}else if(rec.projectLocation && rec.projectLocation.type == 1 && rec.countryInf) {
				return rec.countryInf.countryChinese;
			}
			return '';
		},
		onClickItem(id) {
			this.$router.push({
				path: '/detail?type=project&id=' + id
			});
		},
		async initChart() {
			const that = this;
			this.chart = echarts.init(this.$refs.echart)
			this.chart.showLoading();
			let option = {
				tooltip: {
					trigger: 'item',
					backgroundColor: 'transparent',
					borderColor: '#FFFFCC',
					showDelay: 0,
					hideDelay: 1000,
					enterable: true,
					transitionDuration: 0,
					extraCssText: 'z-index:100',
					formatter: function(params, ticket, callback) {
						return null;
					}
				},
				backgroundColor: "#FFFFFF",
				visualMap: { //图例值控制
					min: 0,
					max: 1,
					calculable: true,
					show: false,
					color: ['#f44336', '#fc9700', '#ffde00', '#ffde00', '#00eaff'],
					textStyle: {
						color: '#fff'
					}
				},
				geo: {
					map: 'china',
					zoom: 1.2,
					label: {
						emphasis: {
							show: false
						}
					},
					roam: false, //是否允许缩放
					itemStyle: {
						normal: {
							color: 'rgba(111,195,178, .2)', //地图背景色
							borderColor: 'rgba(129,141,197,.4)', //省市边界线00fcff 516a89
							borderWidth: 1
						},
						emphasis: {
							color: 'rgba(37, 43, 61, .5)' //悬浮背景
						}
					}
				},
				series: []
			};
			this.chart.setOption(option, true);
			this.echartRect = this.$refs.echart.getBoundingClientRect();
			this.chart.on('mousemove', (params) => {
				if(params.componentType == 'series' && ['effectScatter', 'scatter'].includes(params.componentSubType) ) {
					this.onChartPopList(params.event, params.name)
				}
				//console.log('mousemove=====', params)
			});
			this.chart.on('mouseout', (params) => {
				if(params.componentType == 'series' && ['effectScatter', 'scatter'].includes(params.componentSubType)) {
					//this.onChartMouseover(params.name)
					this.onChartUnPopList(params.event, params.name)
				}
				//console.log('mouseout=====', params)
			});
			this.chart.on('click', (params) => {
				if(params.componentType == 'series' && ['effectScatter', 'scatter'].includes(params.componentSubType)) {
					this.onChartPopList(params.event, params.name)
				}
				//console.log('click=====', params)
			});
			
			this.chart.hideLoading();
			
			this.$nextTick(() => {
				const rect = this.echartRect;
				let zuobiao1 = this.chart.convertFromPixel('geo', [0+15*this.scaleRate, 0+25*this.scaleRate]); // 转换成坐标
				let zuobiao2 = this.chart.convertFromPixel('geo', [rect.width-80*this.scaleRate, 0+25*this.scaleRate]); // 转换成坐标
				let zuobiao3 = this.chart.convertFromPixel('geo', [0+15*this.scaleRate, rect.height-25*this.scaleRate]); // 转换成坐标
				let zuobiao4 = this.chart.convertFromPixel('geo', [rect.width-80*this.scaleRate, rect.height-25*this.scaleRate]); // 转换成坐标
				const fromCoord = {
					name: '浙江',
					value: [119.5313, 29.8773]
				};
				let toCoords = [];
				this.listData.forEach(it => {
					if(it.projectLocation && it.projectLocation.type == 0 && it.projectLocation.provinceTxt) {
						const key = Object.keys(chinaGeoCoordMap)
							.filter(it2 => it.projectLocation.provinceTxt.indexOf(it2) == 0)[0];
						if (key && key != fromCoord.name && toCoords.filter(it2 => it2.name == key).length == 0) {
							toCoords.push({
								name: key,
								value: chinaGeoCoordMap[key]
							});
						}	
					}else if(it.projectLocation && it.projectLocation.type == 1 && it.countryInf) {
						const key = it.countryInf.countryChinese;
						if (key && key != fromCoord.name && toCoords.filter(it2 => it2.name == key).length == 0) {
							let longitude = it.countryInf.longitude;
							if(longitude < 0) {
								longitude = zuobiao2[0] - 10;
							}else if(longitude<zuobiao1[0]) {
								longitude = zuobiao1[0] + 10;
							}else if(zuobiao1>zuobiao2[0]) {
								longitude = zuobiao2[0] - 10;
							}
							let latitude = it.countryInf.latitude;
							if(latitude>zuobiao1[1]) {
								latitude = zuobiao1[1];
							}else if(latitude<zuobiao3[1]) {
								latitude = zuobiao3[1];
							}
							toCoords.push({
								name: key,
								value: [longitude, latitude]
							});
						}	
					}
				})
				//console.log('toCoords', toCoords)
				
				option.series.push({
					type: 'lines',
					zlevel: 2,
					effect: {
						show: true,
						period: 4, //箭头指向速度，值越小速度越快
						trailLength: 0.02, //特效尾迹长度[0,1]值越大，尾迹越长重
						symbol: 'arrow', //箭头图标
						symbolSize: 5, //图标大小
						//color: '#000000'
					},
					lineStyle: {
						normal: {
							width: 1, //尾迹线条宽度
							opacity: 1, //尾迹线条透明度
							curveness: .3, //尾迹线条曲直度
						}
					},
					data: toCoords.map(it => [{
						coord: fromCoord.value,
						value: 0
					}, {
						coord: it.value,
						name: it.name
					}])
				}, {
					type: 'effectScatter',
					coordinateSystem: 'geo',
					zlevel: 2,
					rippleEffect: { //涟漪特效
						period: 4, //动画时间，值越小速度越快
						brushType: 'stroke', //波纹绘制方式 stroke, fill
						scale: 4, //波纹圆环最大限制，值越大波纹越大
						//color: '#FF8C5B'
					},
					label: {
						normal: {
							show: true,
							position: 'right', //显示位置
							offset: [5, 0], //偏移设置
							formatter: function(params) { //圆环显示文字
								return params.data.name;
							},
							fontSize: 14 * that.scaleRate,
							color: 'rgba(0,0,0,.5)',
							fontWeight: 200,
						},
						emphasis: {
							show: true
						}
					},
					symbol: 'circle',
					symbolSize: function(val) {
						return 5 + val[2] * 5; //圆环大小
					},
					itemStyle: {
						normal: {
							show: false,
							color: '#f00'
						}
					},
					data: toCoords.map(it => {
						return {
							name: it.name,
							value: it.value.concat([0])
						}
					})
				}, {
					type: 'scatter',
					show: false,
					coordinateSystem: 'geo',
					zlevel: 2,
					rippleEffect: {
						period: 4,
						brushType: 'stroke',
						scale: 4
					},
					label: {
						normal: {
							show: true,
							position: 'right', //显示位置
							offset: [5, 0], //偏移设置
							formatter: function(params) { //圆环显示文字
								return params.data.name;
							},
							fontSize: 14 * that.scaleRate,
							color: 'rgba(0,0,0,.5)',
							fontWeight: 200,
						},
						emphasis: {
							show: true
						}
					},
					symbol: 'pin',
					symbolSize: 30 * that.scaleRate,
					itemStyle: {
						// 设置symbol的颜色
						normal: {
							color: '#FFFF00'
						}
					},
					data: [{
						name: fromCoord.name,
						value: fromCoord.value
					}],
				});
				this.chart.setOption(option, true);
			});
			
			
		},
		onHoldPopList(event) {
			//console.log('onHoldPopList')
			if(this.curPopListStatus.timeOut) {
				clearTimeout(this.curPopListStatus.timeOut)
			}
		},
		onChartPopList(event, nodeName) {
			//console.log(event, nodeName)
			if(nodeName) this.curPopListStatus.curNodeName = nodeName;
			this.curPopListStatus.show = true;
			this.curPopListStatus.x = event.offsetX;
			this.curPopListStatus.y = event.offsetY;
			
		},
		onChartUnPopList(event, nodeName) {
			if(this.curPopListStatus.timeOut) {
				clearTimeout(this.curPopListStatus.timeOut)
			}
			this.curPopListStatus.timeOut = setTimeout(() => {
				this.curPopListStatus.show = false;
			}, 500);
			//this.curPopListStatus.show = false;
		}
	}
}